import { supabase } from './supabase';

/** Rebuild vector chunks for one content_reference (corpus chat). */
export async function runContentReferenceEmbeddingIndex(referenceId: string): Promise<{
  ok: boolean;
  skipped?: boolean;
  error?: string;
}> {
  if (!referenceId) return { ok: false, error: 'Invalid reference id' };
  const { data, error } = await supabase.functions.invoke<{
    ok?: boolean;
    skipped?: boolean;
    error?: string;
  }>('index-content-reference-chunks', { body: { reference_id: referenceId } });
  if (error) return { ok: false, error: error.message };
  if (data && typeof data === 'object' && typeof data.error === 'string') {
    return { ok: false, error: data.error };
  }
  return { ok: true, skipped: Boolean(data?.skipped) };
}

export function scheduleContentReferenceEmbeddingIndex(referenceId: string): void {
  void runContentReferenceEmbeddingIndex(referenceId).then((r) => {
    if (!r.ok) {
      console.warn('index-content-reference-chunks:', r.error);
    }
  });
}
